import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

export type ActiveRole = 'coach' | 'guardian' | 'athlete' | 'member';

interface ActiveProfile {
  id: string;
  name: string;
}

interface RoleState {
  activeRole: ActiveRole;
  activeProfile: ActiveProfile | null;
  availableRoles: ActiveRole[];
  setActiveRole: (role: ActiveRole) => void;
  setActiveProfile: (profile: ActiveProfile | null) => void;
  setAvailableRoles: (roles: ActiveRole[]) => void;
}

export const useRoleStore = create<RoleState>()(
  persist(
    (set) => ({
      activeRole: 'member',
      activeProfile: null,
      availableRoles: ['member'],

      setActiveRole: (role) => set({ activeRole: role }),
      setActiveProfile: (profile) => set({ activeProfile: profile }),
      setAvailableRoles: (roles) => set({ availableRoles: roles }),
    }),
    {
      name: 'role-storage',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({
        activeRole: state.activeRole,
        activeProfile: state.activeProfile,
      }),
    }
  )
);
